<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    POLÍTICA DE SEGURANÇA DA INFORMAÇÃO
                </p></h1>
            </div>
            <div class="privacy-content">
                <p class="date">
                    Data da última atualização: 30 de abril de 2019
                </p>
                <p>
                    <span>Propósito</span>
                    <br><br>
                    Esta política articula os requisitos que auxiliam a Gerência Geral na definição de uma estrutura que
                    estabeleça um ambiente seguro. Este framework fornece a estrutura geral para salvaguardar os
                    Recursos de Tecnologia da Informação (TI), alcançar a confidencialidade, integridade e
                    disponibilidade dos dados e recursos de TI utilizados na entrega do serviço FAD (Assinatura
                    Autógrafa Digital).<br><br>
                    Todas as áreas da NA-AT Technologies buscam cumprir os objetivos gerais de segurança da informação
                    da empresa, incluindo o cumprimento de leis, regulamentos, políticas e padrões aos quais seus dados
                    e recursos tecnológicos estão sujeitos.<br><br>
                    <span>Escopo da Política de Segurança da Informação</span><br><br>
                    Todos os funcionários da NA-AT Technologies são obrigados a cumprir esta política.<br><br>
                    Todas as áreas da NA-AT Technologies são obrigadas a garantir o cumprimento desta política por
                    qualquer parceiro de negócios que acesse Recursos de TI, ativos de informação ou ambientes
                    compartilhados da empresa para a entrega do serviço de FAD (Assinatura Autógrafa Digital).<br><br>
                    Todas as áreas da NA-AT Technologies são obrigadas a assegurar o cumprimento desta política por
                    parte de fornecedores e terceiros que, por relação contratual, acedem a Recursos de TI, ativos de
                    informação ou ambientes partilhados da empresa para a entrega do serviço FAD (Assinatura Autógrafa
                    Digital).
                    <br><br>
                    <span>Declaração de Política de Segurança da Informação</span><br><br>
                    Por meio desta política, a NA-AT Technologies reitera seu compromisso com a segurança da informação
                    e estabelece a abordagem da organização para gerenciar a segurança da informação em alinhamento com
                    sua estratégia e objetivos de negócios, para os quais:<br>
                </p>
                <ol>
                    <li>Estabelece alinhamento com a estratégia e os objetivos do seu negócio.</li>
                    <li>Estabelece e aprova os critérios de aceitação do risco, bem como a forma de sua gestão.</li>
                    <li>Reconhece que os ativos de informação são essenciais para o seu funcionamento e, portanto,
                        precisam ser adequadamente protegidos, para o que fornece os recursos necessários para a
                        implementação dos controles de segurança.
                    </li>
                    <li>Monitora a eficácia do Sistema de Gestão de Segurança da Informação para garantir a melhoria
                        contínua.
                    </li>
                    <li>Aprova treinamento e conscientização sobre segurança da informação.</li>
                    <li>Garante o estabelecimento de canais de comunicação para a divulgação de políticas, procedimentos
                        e medidas de segurança.
                    </li>
                    <li>Assegura a identificação e o cumprimento das Leis, Normas e Regulamentos aplicáveis ao
                        negócio.
                    </li>
                    <li>Promove aos seus colaboradores internos e fornecedores o conhecimento e cumprimento desta
                        política e de todos os que dela derivam.
                    </li>
                    <br>
                </ol>
                <p>
                    <span>Política Geral de Segurança da Informação</span><br><br>
                    Todos nós que participamos da NA-AT Technologies temos o compromisso de melhorar sistemática e
                    continuamente para nos tornarmos um aliado tecnológico de nossos clientes, construindo relações de
                    longo prazo baseadas em confiança, benefício mútuo e melhores práticas de negócio, com uma crescente
                    consciência ambiental e responsabilidade social.<br><br>
                    Sustentamos nossos serviços em uma cultura de qualidade de pessoas, processos e práticas, seguindo
                    as diretrizes das normas nacionais e internacionais com total aderência às normas vigentes.<br><br>
                    Na NA-AT Technologies temos o compromisso de garantir que a confidencialidade, integridade e
                    disponibilidade dos ativos de informação pelos quais somos responsáveis ​​sejam preservados no
                    ambiente de trabalho, especialmente aqueles relacionados aos nossos clientes, garantindo o
                    cumprimento das políticas, processos e procedimentos de segurança da empresa . Comprometemo-nos a
                    desenvolver, implementar, manter e melhorar continuamente o Sistema de Gestão da Segurança da
                    Informação (SGSI).
                </p>
                <br>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Política de Segurança da Informação</h1>
                <p class="text">
                    Data da última atualização: 30 de abril de 2019
                </p>
                <p class="text">
                    <span>Propósito</span>
                    <br><br>
                    Esta política articula os requisitos que auxiliam a Gerência Geral na definição de uma estrutura que
                    estabeleça um ambiente seguro. Este framework fornece a estrutura geral para salvaguardar os
                    Recursos de Tecnologia da Informação (TI), alcançar a confidencialidade, integridade e
                    disponibilidade dos dados e recursos de TI utilizados na entrega do serviço FAD (Assinatura
                    Autógrafa Digital).<br><br>
                    Todas as áreas da NA-AT Technologies buscam cumprir os objetivos gerais de segurança da informação
                    da empresa, incluindo o cumprimento de leis, regulamentos, políticas e padrões aos quais seus dados
                    e recursos tecnológicos estão sujeitos.<br><br>
                    <span>Escopo da Política de Segurança da Informação</span><br><br>
                    Todos os funcionários da NA-AT Technologies são obrigados a cumprir esta política.<br><br>
                    Todas as áreas da NA-AT Technologies são obrigadas a garantir o cumprimento desta política por
                    qualquer parceiro de negócios que acesse Recursos de TI, ativos de informação ou ambientes
                    compartilhados da empresa para a entrega do serviço de FAD (Assinatura Autógrafa Digital).<br><br>
                    Todas as áreas da NA-AT Technologies são obrigadas a assegurar o cumprimento desta política por
                    parte de fornecedores e terceiros que, por relação contratual, acedem a Recursos de TI, ativos de
                    informação ou ambientes partilhados da empresa para a entrega do serviço FAD (Assinatura Autógrafa
                    Digital).
                    <br><br>
                    <span>Declaração de Política de Segurança da Informação</span><br><br>
                    Por meio desta política, a NA-AT Technologies reitera seu compromisso com a segurança da informação
                    e estabelece a abordagem da organização para gerenciar a segurança da informação em alinhamento com
                    sua estratégia e objetivos de negócios, para os quais:<br>
                </p>
                <ol class="text">
                    <li>Estabelece alinhamento com a estratégia e os objetivos do seu negócio.</li>
                    <li>Estabelece e aprova os critérios de aceitação do risco, bem como a forma de sua gestão.</li>
                    <li>Reconhece que os ativos de informação são essenciais para o seu funcionamento e, portanto,
                        precisam ser adequadamente protegidos, para o que fornece os recursos necessários para a
                        implementação dos controles de segurança.
                    </li>
                    <li>Monitora a eficácia do Sistema de Gestão de Segurança da Informação para garantir a melhoria
                        contínua.
                    </li>
                    <li>Aprova treinamento e conscientização sobre segurança da informação.</li>
                    <li>Garante o estabelecimento de canais de comunicação para a divulgação de políticas, procedimentos
                        e medidas de segurança.
                    </li>
                    <li>Assegura a identificação e o cumprimento das Leis, Normas e Regulamentos aplicáveis ao
                        negócio.
                    </li>
                    <li>Promove aos seus colaboradores internos e fornecedores o conhecimento e cumprimento desta
                        política e de todos os que dela derivam.
                    </li>
                    <br>
                </ol>
                <p class="text">
                    <span>Política Geral de Segurança da Informação</span><br><br>
                    Todos nós que participamos da NA-AT Technologies temos o compromisso de melhorar sistemática e
                    continuamente para nos tornarmos um aliado tecnológico de nossos clientes, construindo relações de
                    longo prazo baseadas em confiança, benefício mútuo e melhores práticas de negócio, com uma crescente
                    consciência ambiental e responsabilidade social.<br><br>
                    Sustentamos nossos serviços em uma cultura de qualidade de pessoas, processos e práticas, seguindo
                    as diretrizes das normas nacionais e internacionais com total aderência às normas vigentes.<br><br>
                    Na NA-AT Technologies temos o compromisso de garantir que a confidencialidade, integridade e
                    disponibilidade dos ativos de informação pelos quais somos responsáveis ​​sejam preservados no
                    ambiente de trabalho, especialmente aqueles relacionados aos nossos clientes, garantindo o
                    cumprimento das políticas, processos e procedimentos de segurança da empresa . Comprometemo-nos a
                    desenvolver, implementar, manter e melhorar continuamente o Sistema de Gestão da Segurança da
                    Informação (SGSI).
                </p>
            </div>

        </div>
    </div>

</app-template>
